export const MAXIMUM_ENDPOINT = 5000; // maximum endpoints
export const MINIMUM_ENDPOINT = 100; // minimum endpoints
export const EDR_DISCOUNT = 0.4; // 40% discount for edr
export const EDR_DISCOUNT_SW = 0.45; // 40% discount for edr enterprisea
export const YEARLY = 12; // to calculate yearly pricing
export const localCurrency = 'us-en';

export const PRICING_TIER_1 = 1;
export const PRICING_TIER_2 = 9;
export const PRICING_TIER_3 = 90;
export const PRICING_TIER_4 = 400;
export const PRICING_TIER_5 = 500;
export const PRICING_TIER_6 = 1500;

export const EDR_SAAS_PN = 'D09EGZX'; // for edr standard
export const EDR_SW_PN = 'D0AE7ZX'; // for edr enterprise

/* Single Tiers for pricing calculation */
export const EDR_TIER_1 = 10000; // single tier
export const EDR_TIER_INF = 999999999; // to define infinite tier

export const EDR_SW_RATIO = 16 / 5;
